export default __webpack_public_path__ + "static/frontend-backend-full-stack-developer-differenze-orangeloop-54419cf9114a8820f3b6fb7cb241ea6f.jpg";